import { useSelector } from 'react-redux';
import { Accordion, Button } from '@integration/alexandria-ui';
import { ButtonContainer, ParagraphContainer } from 'globalStyles/Containers';
import { useTranslateByProject } from 'hooks/translation-hooks';
import {
  contactPhoneSelector,
  numberOfFAQCaseOpeningQuestionsSelector,
  numberOfFAQQuestionsSelector,
  shouldDisplayFAQButtonSelector,
} from 'redux/selectors/config';
import Markdown from 'components/Markdown';
import { useParams } from 'react-router-dom';

export const FAQAccordeon = () => {
  const phoneNumber = useSelector(contactPhoneSelector);
  const showButton = useSelector(shouldDisplayFAQButtonSelector);
  const numberOfFAQQuestions = useSelector(numberOfFAQQuestionsSelector);
  const numberOfFAQCaseOpeningQuestions = useSelector(
    numberOfFAQCaseOpeningQuestionsSelector,
  );
  const { id } = useParams();
  const t = useTranslateByProject();

  const handlePhoneCAll = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const totalQuestions = id
    ? numberOfFAQQuestions
    : numberOfFAQCaseOpeningQuestions;
  const data = [];
  for (let index = 1; index <= totalQuestions - 1; index++) {
    data.push({
      title: t(`faq_page-question_${index}`),
      paragraph: <Markdown text={t(`faq_page-answer_${index}`)} />,
    });
  }
  data.push({
    title: t(`faq_page-question_${totalQuestions}`),
    paragraph: (
      <ParagraphContainer>
        <Markdown text={t(`faq_page-answer_${totalQuestions}`)} />
        {showButton && (
          <ButtonContainer>
            <Button onClick={handlePhoneCAll}>{phoneNumber}</Button>
          </ButtonContainer>
        )}
      </ParagraphContainer>
    ),
  });

  return <Accordion data={data} />;
};

export default FAQAccordeon;
